import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Icon, Modal } from "semantic-ui-react";
import "../BoxManagement/registerbox.css";
import { unRegisteredPillBottle } from "../action/boxAction";

class unregisterPillBottle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      loading: false,
      regiSuccess: false
    };
  }

  handleOpen = () => {
    this.setState({ open: true, regiSuccess: false });
  };
  close = () => this.setState({ open: false });

  handleOK = () => {};

  submit() {
    const creds = {
      userId: this.props.item.userId,
      pillBottleId: this.props.item.pillBottleId
    };
    this.setState({
      loading: true
    });
    unRegisteredPillBottle(creds)
      .then(res => {
        if (res.status) {
          this.setState({
            loading: false,
            regiSuccess: true
          });
          setTimeout(() => {
            this.setState({
              open: false
            });
            if (typeof this.props.onChange === "function") {
              this.props.onChange(creds);
            }
          }, 500);
        } else {
          this.setState({
            loading: false
          });
        }
      })
      .catch(err => {
        this.setState({
          loading: false
        });
      });
  }

  render() {
    const { open } = this.state;
    return (
      <Modal
        trigger={
          <Button onClick={this.handleOpen} size="mini">
            Unregister
          </Button>
        }
        open={open}
        className="add-box-form-container"
      >
        <Modal.Header>
          {this.state.regiSuccess
            ? "UnRegister Pill Bottle success"
            : `Pill Bottle UnRegistration`}
        </Modal.Header>
        <Modal.Content>
          {this.state.regiSuccess ? (
            <div className="regiSuccess">
              <Icon name="check circle" id="regiSuccessIcon" />
              <p className="regiSuccessTitle">Awesome!</p>
              <p className="regiSuccesstext">
                Pill Bottle has been successfully unregistered.
              </p>
            </div>
          ) : (
            <div>
              <div className="search_patient_container">
                Are you sure you want to unregister pill bottle: {this.props.item.pillBottleId}
                ?
              </div>
            </div>
          )}
        </Modal.Content>
        <Modal.Actions>
          {!this.state.regiSuccess && (
            <Button
              color="green"
              loading={this.state.loading}
              onClick={e => this.submit()}
            >
              <Icon name="checkmark" />
              UnRegister Pill Bottle
            </Button>
          )}
          <Button basic color="red" onClick={e => this.close()}>
            <Icon name="remove" />
            {this.state.regiSuccess ? "Close" : "Cancel"}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}
const mapStateToProp = state => ({});

export default connect(mapStateToProp, null)(unregisterPillBottle);
